import { useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { CALL_CONTEXT_QUERY_KEY } from 'helpers/queries/call-context';
import { CallContextModel } from 'pages/shared/models/callcontext';

// Subscribe-only reader: shares the same query key as useGetCallContext so every
// consumer re-renders when the context resolves, but never triggers its own fetch.
export const useCallContext = (): UseQueryResult<CallContextModel> => {
  const queryClient = useQueryClient();
  const queryKey = CALL_CONTEXT_QUERY_KEY;
  return useQuery<CallContextModel>({
    queryKey,
    enabled: false,
    queryFn: async () => queryClient.getQueryData<CallContextModel>(queryKey) as CallContextModel,
  });
};
